// extracted by mini-css-extract-plugin
export default {"sideCharacter":"sideCharacters_sideCharacter__5xrb8","sideCharacterLeft":"sideCharacters_sideCharacterLeft__QvmtJ","sideCharacterRight":"sideCharacters_sideCharacterRight__LLrgq"};